export const API_VALIDATOR_KEYS = {
  USER: "user",
  PROJECTS: {
    PROJECT: "project",
    DOCKET: "docket",
    INVOICE: "invoice",
    WASTE_REPORT: "waste-report",
  },
  INVOICES: "invoices",
  WASTE_MANAGEMENT: {
    SUMMARY: "summary",
  },
  WARE_HOUSING: {
    BASE: "warehousing",
    ITEMS: "warehousingDetailItems",
    PROJECTS: "warehousingDetailProjects",
    HISTORY: "warehousingDetailsAssignHistory",
  },
  DASHBOARD: {
    BASE: "dashboard",
    DASHBOARD_FINANCE: "dashboard-finance",
  },
};
